<form [formGroup]="formGroup()">
  <div class="grid grid-cols-1 gap-4">
    <div class="flex flex-col gap-2">
      <label class="font-bold" for="number" appRequiredLabel="numerKonta"
        >Numer konta bankowego</label
      >
      <p-input-mask
        [style]="{ width: '50%' }"
        mask="99 9999 9999 9999 9999 9999 9999"
        [formControl]="formGroup().controls.numerKonta"
        placeholder="__ ____ ____ ____ ____ ____ ____"
        [autoClear]="false"
        slotChar="_"
        [unmask]="true"
        appControlError
        id="number"
        inputId="number"
        (onInput)="moveAccountNumberCaret($event)"
      ></p-input-mask>
    </div>
    <div class="col-span-2">
      <p-checkbox
        [formControl]="formGroup().controls.nieJestWlascicielem"
        [binary]="true"
        [inputId]="'isOwner'"
        styleClass="customCheckbox"
      />
      <label [for]="'isOwner'" class="ml-2 my-4"
        >Nie jestem właścicielem podanego rachunku bankowego</label
      >
    </div>
    @if (formGroup().controls.nieJestWlascicielem.value) {
      <div class="flex flex-col gap-2 md:col-span-2">
        <label
          class="font-bold"
          for="ownerDetails"
          appRequiredLabel="daneWlasciciela"
          >Imię i nazwisko właściciela rachunku bankowego</label
        >
        <input
          id="ownerDetails"
          [maxlength]="150"
          pInputText
          appControlError
          [formControl]="formGroup().controls.daneWlasciciela"
        />
      </div>
    }
  </div>
</form>
